import React, { memo, useContext } from 'react';
import { ScaleContext } from '../../context/ScaleContext';
import './Controls.css';

const Controls = () => {
  const { increaseScale, decreaseScale, resetScale } = useContext(ScaleContext);

  return (
    <div className='editor-control'>
      <button className='round-button' onClick={increaseScale}>+</button>
      <button className='round-button' onClick={resetScale}>.</button>
      <button className='round-button' onClick={decreaseScale}>-</button>
    </div>
  );
};

export default memo(Controls);